/**
 * Contains builders for html elements
 */
namespace appn.elementBuilder {

    export function buildAppnSelect(items: Array<AppnSelectListItem>, id: string, classes?: string, allText?: string, name?: string): string {
        if (name)
            name = ` name="${name}"`;
        let itemsHtml = `<select id="${id}" class="form-control-sm form-control ${classes}"${name ? name : appn.emptyString}>`;
        if (allText)
            itemsHtml += `<option value = "" >${allText}</option>`;

        for (let i = 0; i < items.length; i++) {
            const item = items[i] as AppnSelectListItem;
            itemsHtml += '<option ';

            if (item.hasOwnProperty('DataTag') && item.dataTag) {
                itemsHtml += item.dataTag;
                if (item.hasOwnProperty('DataValue') && item.dataValue)
                    itemsHtml += `="${selectOptionCleanup(item.dataValue)}" `;
            }

            if (item.hasOwnProperty('DataTag2') && item.dataTag2) {
                itemsHtml += item.dataTag2;
                if (item.hasOwnProperty('DataValue2') && item.dataValue2)
                    itemsHtml += `="${selectOptionCleanup(item.dataValue2)}" `;
            }

            if (item.hasOwnProperty('DataTag3') && item.dataTag3) {
                itemsHtml += item.dataTag3;
                if (item.hasOwnProperty('DataValue3') && item.dataValue3)
                    itemsHtml += `="${selectOptionCleanup(item.dataValue3)}" `;
            }

            let selected: string = appn.emptyString;
            if (item.selected)
                selected = ' selected="selected"';
            itemsHtml += ` value="${item.value}"${selected}>${item.text}</option>`;
        }

        itemsHtml += '</select>';

        return itemsHtml;
    }

    export function buildSelectGeneric(items: Array<SelectListItem>, id: string, classes: string, allText?: string, name?: string, additionalStyle?: string): string {

        let styleText: string = appn.emptyString;
        if (additionalStyle && additionalStyle !== appn.emptyString)
            styleText = ` style="${additionalStyle}"`;

        let nameText: string = appn.emptyString;
        if (name && name !== appn.emptyString)
            nameText = ` name=${name}`;

        let itemsHtml = `<select id="${id}"${styleText}${nameText} class="${classes}">`;

        if (allText && allText !== appn.emptyString)
            itemsHtml += `<option value = "" >${allText}</option>`;

        if (utils.hasValue(items))
            for (let i = 0; i < items.length; i++) {
                let selected: string = appn.emptyString;
                const item = items[i] as SelectListItem;
                if (item.selected)
                    selected = ' selected="selected"';
                itemsHtml += `<option value="${item.value}"${selected}>${item.text}</option>`;
            }

        itemsHtml += '</select>';

        return itemsHtml;
    }

    export function buildSelect(items: Array<SelectListItem>, id: string, classes: string, allText?: string, name?: string, additionalStyle?: string): string {

        let styleText: string = appn.emptyString;
        if (additionalStyle && additionalStyle !== appn.emptyString)
            styleText = ` style="${additionalStyle}"`;

        let nameText: string = appn.emptyString;
        if (name && name !== appn.emptyString)
            nameText = ` name=${name}`;

        let itemsHtml = `<select id="${id}"${styleText}${nameText} class="form-control-sm form-control ${classes}">`;

        if (allText && allText !== appn.emptyString)
            itemsHtml += `<option value = "" >${allText}</option>`;

        if (utils.hasValue(items))
            for (let i = 0; i < items.length; i++) {
                let selected: string = appn.emptyString;
                const item = items[i] as SelectListItem;
                if (item.selected)
                    selected = ' selected="selected"';
                itemsHtml += `<option value="${item.value}"${selected}>${item.text}</option>`;
            }

        itemsHtml += '</select>';

        return itemsHtml;
    }

    export function buildOptionsListSelectList(items: Array<any>, allText?: string, optGroupInjector?: OptGroupInjector): string {
        let optionsHtml = emptyString;

        if (allText)
            optionsHtml += `<option value = "" >${allText}</option>`;

        items.forEach(function(item, index: number) {
            if (optGroupInjector && optGroupInjector.groupName) {
                if (index === optGroupInjector.startIndex)
                    optionsHtml += `<optgroup label="${optGroupInjector.groupName}">`;

                if (index === optGroupInjector.endIndex)
                    optionsHtml += `</optgroup>`;
            }

            optionsHtml += `<option value="${item.Value}">${item.Text}</option>`;
        });

        return optionsHtml;
    }

    export function buildOptionsList(items: string[], allText?: string): string {
        let optionsHtml = emptyString;

        if (allText)
            optionsHtml += `<option value = "" >${allText}</option>`;

        items.forEach(function(item, index) {
            optionsHtml += `<option value="${item}">${item}</option>`;
        });

        return optionsHtml;
    }

    export function buildArraySelect(items: string[], id: string, classes?: string, allText?: string, name?: string): string {
        if (name)
            name = ` name="${name}"`;
        let itemsHtml = `<select style="margin-left: 0.5em;" id="${id}" class="form-control-sm form-control ${classes}"${name ? name : appn.emptyString}>`;

        itemsHtml += buildOptionsList(items, allText);
        itemsHtml += '</select>';

        return itemsHtml;
    }

    export function buildTaskStatusSelect(statuses: Array<any>, id: string, classes: string): string {

        let itemsHtml = `<select id="${id}" class="form-control-sm form-control ${classes}">
                <option value="All">${T("ALL STATUSES")}</option>
                <option value="AllIncomplete">${T("ALL INCOMPLETE")}</option>`;

        for (let i = 0; i < statuses.length; i++)
            itemsHtml += `<option class="" value="${statuses[i].Value}">${statuses[i].Display}</option>`;

        itemsHtml += '</select>';

        return itemsHtml;
    }

    export function buildCheckbox(text: string, inputClasses?: string, id?: string, color?: ICheckColor, name?: string, includeHiddenInput?: boolean, isChecked?: boolean): string {
        return `<div class="icheck-${color ? color : ICheckColor.primary} appn-checkbox"><input class="${(inputClasses ? inputClasses : emptyString)}" type="checkbox" id="${(id ? id : emptyString)}">${(includeHiddenInput ? `<input name="${name}" type="hidden" value="${(isChecked ? 'true' : 'false')}">` : emptyString)}<label for="${(id ? id : emptyString)}">${(text ? text : emptyString)}</label></div>`;
    }

    export function buildCheckboxWithHint(text: string, hint: string, inputClasses?: string, id?: string, color?: ICheckColor, name?: string, includeHiddenInput?: boolean, isChecked?: boolean): string {
        return `<div class="icheck-${color ? color : ICheckColor.primary} appn-checkbox"><input class="${(inputClasses ? inputClasses : emptyString)}" type="checkbox" id="${(id ? id : emptyString)}">${(includeHiddenInput ? `<input name="${name}" type="hidden" value="${(isChecked ? 'true' : 'false')}">` : emptyString)}
                    <label for="${(id ? id : emptyString)}">
                        <span data-widget="popover" data-trigger="manual" data-html="true" data-placement="top" data-content="${(hint ? hint : emptyString)} " data-original-title="" title="">
                            <span>${(text ? text : emptyString)}</span>
                            <i class="fa fa-question-circle"></i>
                        </span>
                    </label>
                </div>`;
    }

    export function buildCardHideButton(classes?: string, attributes?: string): string {
        return `<button type="button" class="btn btn-tool card-btn-expand-or-collapse ${(classes ? classes : emptyString)}" ${(attributes ? attributes : emptyString)} ><i class="fas fa-times"></i></button>`;
    }

    export function buildBtnRemoveRow(classes?: string, attributes?: string): string {
        return `<button type="button" class="btn-remove-row btn btn-outline-danger btn-icon-round btn-sm float-right ${(classes ? classes : emptyString)}" ${(attributes ? attributes : emptyString)}><i class="fa fa-times"></i></button>`;
    }

    export function buildBtnMoveRow(isUpDirection: boolean, classes?: string, attributes?: string): string {
        const direction = isUpDirection ? 'up' : 'down';
        return `<button type="button" class="btn-move-${direction} btn btn-outline-secondary btn-icon-round ${direction}_button btn-sm ${(classes ? classes : emptyString)}" ${(attributes ? attributes : emptyString)}><i class="fa fa-chevron-${direction}"></i></button>`;
    }

    export function buildIconButton(formulaType?: string): string {
        return `<button ${formulaType ? `data-type="${formulaType}"`: emptyString} class="fa fa-hammer btn btn-secondary buildIcon" type="button"><i></i></button>`;
    }

    export function buildLinkBtn(text: string, link: string, classes?: string, id?: string): string {
        return `<a href="${link}" id="${id}" class="btn ${classes}">${text}</a>`;
    }

    export function buildLinkTag(text: string, link: string, classes?: string, id?: string): string {
        return `<a href="${link}" id="${id}" class="btn btn-link ${classes}">${text}</a>`;
    }

    function selectOptionCleanup(dataValue: string) {
        // NB all combinations of \r and \n need to be completed.  
        //    Separate replace of these will not work to replace the combination.
        return dataValue
            .replace('\r\n', appn.emptyString)
            .replace('\r', appn.emptyString)
            .replace('\n', appn.emptyString)
            .replace('\t', appn.emptyString).trim();
    }

    export interface OptGroupInjector {
        groupName: string;
        startIndex: number;
        endIndex: number;
    }

    // Generic Element Generation
    /**
     * Will create a generic element of type HTMLElement but will not accept any advanced parameters
     *  this is useful for container elements like div, span, ul, li, etc. Attributes can be set with
     *  an Array<[string,string]> correlating to [attr, val][].
     * @param tagName required
     * @param includeEmptyAtrributes set to true if we do NOT want to strip out empty attributes
     */
    export function createElement(tagName: string, className?: string | Array<string>, id?: string, attributes?: Array<[string, string]>, innerHTML?: string, includeEmptyAtrributes: boolean = false): HTMLElement {
        const element = document.createElement(tagName);
        if (className)
            if (Array.isArray(className))
                element.className = className.join(' ');
            else
                element.className = className;

        if (id)
            element.id = id;

        if (attributes && Array.isArray(attributes) && attributes.length > 0)
            joinAttributes(attributes).forEach((attribute: [string, string]) => {
                if (includeEmptyAtrributes || attribute[1] !== emptyString)
                    element.setAttribute(attribute[0], attribute[1]);
            });

        if (innerHTML)
            element.innerHTML = innerHTML;

        return element;
    }

    /**
     * A helper that can create any type of input field with the 'input' tag
     * @param checked only for checkboxes
     */
    export function getSimpleInputFor(className?: string | Array<string>, name?: string, id?: string, type?: HTMLInputType, placeholder?: string, value?: string | number, required: boolean = false, checked: boolean = false): HTMLElement {
        const textInput = document.createElement('input');
        if (className)
            if (Array.isArray(className))
                textInput.className = className.join(' ');
            else
                textInput.className = className;

        if (name)
            textInput.name = name;

        if (id)
            textInput.id = id;

        if (type)
            textInput.type = type;

        if (placeholder)
            textInput.placeholder = placeholder;

        if (value)
            textInput.value = value.toString();

        textInput.required = required;

        if (type === HTMLInputType.CheckBox)
            textInput.checked = checked;

        return textInput;
    }

    /**
     * Gets only the <i class="className" attrs/> element
     * @param className required font awesome icon class name
     * @param includeEmptyAtrributes set to true if we do NOT want to strip out empty attributes
     */
    export function getIconFor(className: string, attributes?: Array<[string, string]>, includeEmptyAtrributes: boolean = false): HTMLElement {
        const icon = document.createElement('i');
        icon.className = className;

        if (attributes && Array.isArray(attributes) && attributes.length > 0)
            joinAttributes(attributes).forEach((attribute: [string, string]) => {
                if (includeEmptyAtrributes || attribute[1] !== emptyString)
                    icon.setAttribute(attribute[0], attribute[1]);
            });

        return icon;
    }

    /**
     * This function is for when we want to use arbitrary indexing for a list of objects in the form
     *  where the list of items can have items removed in random locations and will maintain the 
     *  indexed integrity without having to reindex fields iteratively on edit.
     * @param name the model name for the object you'd like to add indexer for i.e. 'Model.Object.ListObject'
     * @param value the current index value, generally from a global iterrated value
     * @param addPrefix true if there is already a list of said indexed object and we want to add to it
     */
    export function getHiddenIndexerFor(name: string, value: number, addPrefix: boolean = true): HTMLElement {
        const indexInput = document.createElement('input');
        indexInput.type = HTMLInputType.Hidden;
        indexInput.name = `${name}.Index`;
        indexInput.value = addPrefix ? `new-${value}` : value.toString();

        return indexInput;
    }

    // Generic element helpers
    /**
     * Ensures that if an attribute name is mentioned in duplicate, that we join them together to avoid issues
     *  with IE users (avoid edge cases)
     */
    function joinAttributes(attributes: Array<[string, string]>): Array<[string, string]> {
        const filteredAttributes = attributes.map(item => item[0]).filter((value: string, index: number, self) => {
            return self.indexOf(value) === index;
        });

        const joinedAttributes: Array<[string, string]> = [];
        filteredAttributes.forEach((attrName: string) => {
            const attr = attributes.filter((attribute: [string, string], index: number, self) => {
                return attribute[0] === attrName;
            });

            const values: Array<string> = [];
            attr.forEach((currentAttr: [string, string]) => {
                values.push(currentAttr[1]);
            });

            joinedAttributes.push([attrName, values.join(' ')]);
        });

        return joinedAttributes;
    }

    // Composite Element Generation
    /**
     * Creates selectOne and selectMulti depending on type parameter
     * @param type required
     * @param values required option value
     * @param display required option text
     * @param displayTextSpacePlaceholder if a space placeholder was used for display values as they allow spaces but having spaces cause issues in attributes
     */
    export function getSelectListFor(type: HTMLElementType, values: Array<string>, display: Array<string>, className?: string | Array<string>, name?: string, id?: string, displayTextSpacePlaceholder?: string, required: boolean = false): HTMLElement {
        const selectInput = document.createElement('select');
        if (className)
            if (Array.isArray(className))
                selectInput.className = className.join(' ');
            else
                selectInput.className = className;

        if (name)
            selectInput.name = name;

        if (id)
            selectInput.id = id;

        if (type === HTMLElementType.SelectMulti)
            selectInput.multiple = true;

        selectInput.required = required;

        values.forEach((value: string, index: number) => {
            let displayText = display[index];
            if (displayTextSpacePlaceholder)
                displayText = display[index].replace(displayTextSpacePlaceholder, ' ');

            const option = document.createElement('option');
            option.value = value;
            option.text = displayText;

            selectInput.appendChild(option);
        });

        return selectInput;
    }

    /**
     * Creates Date/Time/DateTime input depending on type
     * @param type required input type
     */
    export function getDateTimePickerFor(type: HTMLElementType, className ?: string | Array <string>, name ?: string, id ?: string, placeholder ?: string, value ?: string | number, required: boolean = false): HTMLElement {
        let iconClass = 'fa';

        switch (type) {
            case HTMLElementType.Date:
            case HTMLElementType.DateTime: {
                iconClass += ' fa-calendar fa-xs';

                break;
            }
            case HTMLElementType.Time: {
                iconClass += ' fa-clock fa-xs';

                break;
            }
        }
        const groupAddonButton = createElement('button', 'input-group-text btn btn-secondary', undefined, [['type', 'button']]);
        groupAddonButton.appendChild(createElement('i', iconClass));
        const groupAddon = createElement('div', 'input-group-append input-group-addon');
        groupAddon.appendChild(groupAddonButton);

        const input = getSimpleInputFor(className, name, id, HTMLInputType.Text, undefined, undefined, required);
        const container = createElement('div', `input-group date ${type.toLowerCase()}picker`);
        container.appendChild(input);
        container.appendChild(groupAddon);

        return container;
    }

    // TaskPreset/Presets and Tasks/Presets Table element builder
    export function getNewRow(select: HTMLElement, dataName: string, dataValue: boolean, presetId: string, type: RowType = RowType.Default, dataNamesUsed: Array<Array<string>>): HTMLElement {
        // Get The current selection details
        const presetTableBody = $(`#fields_${presetId} tbody`);
        const option = type !== RowType.Page ? $(`option[value="${dataName}"]`) : $(`optgroup[label="${dataName}"]`);
        const parentName = option.attr('parent') as string; // The data name of the parent in the designer for this element
        const questionText = option.data('qt'); // Also known as TitleText
        const parentRow = $(`#fields_${presetId} tbody #${parentName}`);
        const hasParentRow = parentRow.length > 0 ? true : false;
        const id = option.data('index');
        let level = 0;
        let rowClass = '';

        if (type === RowType.Default) {
            level = Number(option.attr('level'));
            rowClass = 'preset-page-child';

            if (level === 1)
                rowClass = 'preset-table-child';
        }

        if (type === RowType.Table)
            rowClass = 'preset-table-header';

        if (type === RowType.Page)
            rowClass = 'preset-page-header';

        const row = elementBuilder.createElement('tr', rowClass, undefined, [['data-index', id], ['parent', parentName ?? emptyString]]);

        switch (type) {
            case RowType.Page: {
                // Page header
                const cellPageHeader = elementBuilder.createElement('td', undefined, undefined, [['colspan', '4']]);
                cellPageHeader.appendChild(elementBuilder.createElement('h4', undefined, undefined, undefined, `${questionText} (${dataName})`));

                row.appendChild(cellPageHeader);
                row.id = dataName;

                break;
            }
            case RowType.Table: {
                // First Perform a check to see that this child's parent exists and add if not added
                if (!hasParentRow)
                    presetTableBody.append(getNewRow(select, parentName, false, presetId, RowType.Page, dataNamesUsed));

                const requiredInputHidden = elementBuilder.getSimpleInputFor(undefined,
                    `Template.Presets[${presetId}].Fields[${id}].DataName`,
                    `Template__Presets_${presetId}__Fields_${id}__DataName`,
                    elementBuilder.HTMLInputType.Hidden, undefined, dataName);

                // Table header
                const cellTableHeader = elementBuilder.createElement('td', undefined, undefined, [['colspan', '4']]);
                cellTableHeader.appendChild(elementBuilder.getHiddenIndexerFor(`Template.Presets[${presetId}].Fields`, id, false));
                cellTableHeader.appendChild(elementBuilder.createElement('h4', undefined, undefined, undefined, `${questionText} (${dataName})`));
                cellTableHeader.appendChild(requiredInputHidden);

                row.appendChild(cellTableHeader);
                row.id = dataName;

                break;
            }
            case RowType.Default: {
                // First Perform a check to see that this child's parent exists and add if not added
                if (!hasParentRow) {
                    const preset = dataNamesUsed[Number(presetId)];
                    let isSet = false;
                    if (preset && preset.length > 0)
                        preset.forEach(function(dataSet: string, index: number) {
                            const dataName = dataSet.split('|')[0];
                            const dataValue = dataSet.split('|')[1].toBooleanExact();

                            if (dataName === parentName)
                                isSet = dataValue;
                        });

                    presetTableBody.append(getNewRow(select, parentName, isSet, presetId, level === 0 ? RowType.Page : RowType.Table, dataNamesUsed));
                }

                // Normal row
                // Data Name
                const cellDataName = elementBuilder.createElement('td', undefined, undefined, undefined, dataName);
                row.appendChild(cellDataName);

                // Question Text
                const cellQuestionText = elementBuilder.createElement('td', undefined, undefined, undefined, questionText);
                row.appendChild(cellQuestionText);

                // Required
                const requiredInputHidden = elementBuilder.getSimpleInputFor(undefined,
                    `Template.Presets[${presetId}].Fields[${id}].DataName`,
                    `Template__Presets_${presetId}__Fields_${id}__DataName`,
                    elementBuilder.HTMLInputType.Hidden, undefined, dataName);

                const requiredInput = elementBuilder.buildCheckbox('', 'task-template-preset-required', `Template__Presets_${presetId}__Fields_${id}__Required`, elementBuilder.ICheckColor.primary, `Template.Presets[${presetId}].Fields[${id}].Required`, true, dataValue);

                const cellRequired = elementBuilder.createElement('td', 'dataCol');
                cellRequired.append(elementBuilder.getHiddenIndexerFor(`Template.Presets[${presetId}].Fields`, id, false));
                cellRequired.append(requiredInputHidden);
                cellRequired.append(requiredInput.toHtmlElement());

                row.appendChild(cellRequired);

                // Action
                const actionIcon = elementBuilder.buildBtnRemoveRow('delete_button', `data-index="" data-name="${dataName}"`);

                const cellAction = elementBuilder.createElement('td', 'closeCell');
                cellAction.append(actionIcon.toHtmlElement());

                row.append(cellAction);

                break;
            }
        }

        return row;
    }

    export enum HTMLInputType {
        Text = 'text',
        Number = 'number',
        Hidden = 'hidden',
        CheckBox = 'checkbox'
    }

    export enum HTMLElementType {
        // Date and Time
        Date = 'Date',
        DateTime = 'DateTime',
        Time = 'Time',

        // Select Lists
        SelectOne = 'SelectOne',
        SelectMulti = 'SelectMulti',

        // Generic inputs
        Text = 'Text',
        Decimal = 'Decimal',
        Integer = 'Integer',
        Long = 'Long',
        Hidden = 'Hidden',

        // Checkboxes
        Boolean = 'Boolean',

        // Misc
        Rest = 'Rest'
    }

    export enum RowType {
        Page = 'Page',
        Table = 'Table',
        Default = 'Default'
    }

    export enum ICheckColor {
        primary = 'primary',
        success = 'success',
        info = 'info',
        warning = 'warning',
        danger = 'danger',
        default = 'default'
    }
}

